import React, { LabelHTMLAttributes } from 'react'

import styled from '@emotion/styled'

import LoadingIcon from './LoadingIcon'
import { RadioButton } from './RadioButton'
import { RadioInputAndLabel } from './RadioInput'
import { RadioInputLabelProps } from './RadioInputLabel'

export type RadioInputProps = {
  label: React.ReactNode
  loading?: boolean
  name?: string
  value?: string
  id: string
  onClick?: (e: React.SyntheticEvent) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  StyledLabelComponent?: React.ComponentType<RadioInputLabelProps & LabelHTMLAttributes<HTMLLabelElement>>
} & RadioInputLabelProps

const InlineRadioInputAndLabel = styled(RadioInputAndLabel)`
  width: fit-content;
`

const InnerLabel = styled.label<{ checked?: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  cursor: pointer;

  ${props => props.checked && `color: ${props.theme.colors.label};`}
`

const ButtonWrapper = styled.div`
  height: 1.5rem;
  margin-right: 1.25rem;
`

const Input = styled.input`
  cursor: pointer;
`

const RadioInputInline = (props: RadioInputProps) => {
  const { onChange, onClick, checked, value, disabled, label, invalid, id, loading, animate = true, ...rest } = props

  const ariaLabelId = `radio-input-${id}`

  return (
    <InlineRadioInputAndLabel>
      <Input
        type="radio"
        checked={checked}
        id={id}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
        value={value}
        tabIndex={0}
        {...rest}
      />
      <InnerLabel id={ariaLabelId} htmlFor={id} checked={checked}>
        <ButtonWrapper>
          {loading ? (
            <LoadingIcon size="1.5rem" />
          ) : (
            <RadioButton
              animate={animate}
              aria-checked={checked === true}
              disabled={disabled}
              role="radio"
              aria-labelledby={ariaLabelId}
              checked={checked}
            />
          )}
        </ButtonWrapper>
        {label}
      </InnerLabel>
    </InlineRadioInputAndLabel>
  )
}

RadioInputInline.displayName = 'RadioInputInline'
export default RadioInputInline
